import { NO_FILE_ERROR, useParseCSVFile } from '@cmg/common';
import React from 'react';

import { allocationSharesHeaderMapping, investorNameHeaderMapping } from '../column-definitions';
import { useUploadParticipation } from './useUploadParticipation';

const requiredFields = [investorNameHeaderMapping, allocationSharesHeaderMapping];

export const validateCSVHeaders = (
  headers: string[]
): {
  isValid: boolean;
  error?: string;
} => {
  // require all fields
  const missingFields = requiredFields.filter(({ acceptedHeaders }) => {
    const matched = acceptedHeaders.filter(acceptedHeader => headers.includes(acceptedHeader));
    return matched.length === 0;
  });
  if (missingFields.length > 0) {
    const missingFieldsMessage =
      missingFields.length > 0 ? missingFields.map(item => item.displayName).join(', ') : '';
    return {
      isValid: false,
      error: `Required columns are missing in your file: ${missingFieldsMessage}`,
    };
  }
  return {
    isValid: true,
  };
};
type UseImportSetRouteViewModelParams = { offeringId: string; onCompleted?: () => void };

export const useImportSetRouteViewModel = ({
  offeringId,
  onCompleted,
}: UseImportSetRouteViewModelParams) => {
  const [userError, setUserError] = React.useState<string | undefined>();
  const {
    selectedFile,
    handleFileInputChange,
    headers,
    error: parseError,
    handleReset,
  } = useParseCSVFile({ validateHeaders: validateCSVHeaders });
  const { uploadSet, uploadResult } = useUploadParticipation({
    offeringId,
    participationRecordsInput: selectedFile,
    onCompleted,
    headers,
  });
  const error = React.useMemo(() => {
    return parseError ?? userError;
  }, [parseError, userError]);

  const handleUpload = () => {
    if (!selectedFile) {
      setUserError(NO_FILE_ERROR);
      return;
    }
    !error && uploadSet();
  };
  const resetUserError = () => {
    setUserError(undefined);
  };

  return {
    selectedFile,
    handleFileInputChange: (event: React.ChangeEvent<HTMLInputElement>) => {
      resetUserError();
      handleFileInputChange(event);
    },
    handleReset: () => {
      handleReset();
      resetUserError();
    },
    error,
    headers,
    uploadSet: handleUpload,
    uploadResult,
  };
};
